//
// Copyright (c) 2011-2024 by Curalate, Inc.
//

// Constants and utilities used across the page
export const TABLE_SEARCH_BAR_WIDTH = '284px';
